import { render, staticRenderFns } from "./assets-list.vue?vue&type=template&id=598186cc"
import script from "./assets-list.vue?vue&type=script&lang=js"
export * from "./assets-list.vue?vue&type=script&lang=js"
import style0 from "./assets-list.vue?vue&type=style&index=0&id=598186cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports